function executeCallbacks(...callbacks) {
    return (...args) => {
        for (const callback of callbacks) {
            callback === null || callback === void 0 ? void 0 : callback(...args);
        }
    };
}
export default executeCallbacks;
//# sourceMappingURL=execute-callbacks.js.map